module.exports = __webpack_public_path__ + "img/97.2188fa84.jpg";